import { getMetaSiteId } from '../store/instance-values/instance-values-selectors';

export const getIframeSandboxDomain = (state) => `https://${getMetaSiteId(state)}.usrfiles.com`;
